/* eslint-disable */
import React, { useEffect, useState, useRef, FC } from 'react';
import { css } from 'linaria';
import cn from 'clsx';
import throttle from 'lodash.throttle';

import SlatButton from '../SlatButton';

import DesktopSearchInputSearchBC from '../NavbarSearchBC/Desktop/DesktopSearchInputSearchBC';
import MobileSearchField from '../MobileSearchField';

import { SIZE_SM } from '../../utils/screens';

import useWithinSizeList from '../../hooks/useWithinSizeList';
import useEdgeExperiment from '../../hooks/useEdgeExperiment';
import useMobile from '../../hooks/useMobile';

// Hide the button lists if its AR is .45 or more...
const VideoContainerStyles = css`
  @media (min-aspect-ratio: 20/9) {
    & .button-container {
      display: none;
    }
  }
`;

const HeightFixer = css`
  min-height: 30rem;

  @screen lg {
    height: calc(105vh - 8rem);
  }
`;

const TextContainerStyles = css`
  margin-top: 7.5vh;
  max-width: 75rem;
  width: 85%;
  margin-left: auto;
  margin-right: auto;

  @screen md {
    margin-top: 1.5rem;

    & > h1 {
      margin-left: auto;
      margin-right: auto;
      max-width: 32rem;
    }

    &.has-link-bar > div {
      flex: 0 0 1.5rem;
      height: 1.5rem;
      overflow: hidden;
      flex-wrap: wrap;
    }
  }

  @screen lg {
    & h1 {
      max-width: none;
    }
  }
`;

interface Props {
  className?: string;
  titleMobile: string;
  titleDesktop: string;
  mobilePoster: any;
  mobileVideo: any;
  poster: any;
  video: any;
  navButtons: any[];
}

const HomeHero: FC<Props> = ({
  className,
  titleMobile,
  titleDesktop,
  mobilePoster,
  mobileVideo,
  poster,
  video,
  navButtons,
}) => {
  const isMobile = useMobile();
  const isSmall = useWithinSizeList([SIZE_SM]);
  const containerRef = useRef<any>();
  const [firstRun, setFirstRun] = useState(false);
  const [dimensions, setDimensions] = useState({
    height: 720,
    width: 1280,
  });
  const handleResize = function () {
    setDimensions({
      height: containerRef.current.offsetHeight,
      width: containerRef.current.offsetWidth,
    });
  };

  const election = useEdgeExperiment('search_prominence');
  const variantId = election?.variantId || 1;

  useEffect(() => {
    const throttledHandleWindowResize = throttle(handleResize, 250);

    if (!firstRun) {
      handleResize();
      setFirstRun(true);
    }

    window.addEventListener('resize', throttledHandleWindowResize);

    return () => window.removeEventListener('resize', throttledHandleWindowResize);
  }, [handleResize]);

  let titleStyle;
  if (!isSmall) {
    const videoAspectRatio = 1.76;

    let intendedHeight, compHeight, availableHeight;
    // Width constrained...
    if (dimensions.width / dimensions.height > videoAspectRatio) {
      intendedHeight = Math.round(dimensions.width / videoAspectRatio);
      compHeight = intendedHeight * 0.468;
      availableHeight = dimensions.height - compHeight;
    }
    // Height constrained...
    else {
      compHeight = dimensions.height * 0.468;
      availableHeight = dimensions.height - compHeight;
    }

    titleStyle = { height: `${availableHeight}px` };
  }

  let actionContent;
  let showLinkBar = true;

  if (variantId !== 3) {
    actionContent = navButtons && navButtons.map && (
      <div className="flex w-full justify-center md:space-x-8 text-white button-container">
        {navButtons.map((button, index) => (
          <SlatButton
            key={button.children}
            {...button}
            tracking={{ identifier: `button_${index}` }}
          />
        ))}
      </div>
    );
  } else {
    showLinkBar = false;
    actionContent = isMobile ? <MobileSearchField /> : <DesktopSearchInputSearchBC />;
  }

  return (
    <>
      <div
        className={cn(
          'flex box-content justify-center text-center md:px-6 md:pt-6',
          VideoContainerStyles,
          HeightFixer
        )}
        ref={containerRef}
      >
        <div className={cn('w-full relative', HeightFixer)}>
          <video
            className="w-full h-full object-cover object-bottom -z-1"
            autoPlay
            loop
            muted
            playsInline
            preload="none"
            crossOrigin="anonymous"
            x-webkit-airplay="deny"
            src={isSmall ? mobileVideo : video}
            poster={isSmall ? mobilePoster : poster}
            disableRemotePlayback={true}
          />
        </div>
        <div
          className={cn(
            'absolute flex flex-col justify-center top-0 left-0 right-0 mx-6 md:mx-14 lg:mx-auto',
            {
              'has-link-bar': showLinkBar,
              '!mt-[4vh] !md:mt-6': !showLinkBar,
            },
            TextContainerStyles
          )}
          style={titleStyle}
        >
          <h1 className="heading-serif-small md:heading-serif-medium lg:heading-serif-xlarge xl:heading-serif-xxlarge text-white mb-4 md:mb-6">
            {isSmall ? titleMobile : titleDesktop}
          </h1>
          {actionContent}
        </div>
      </div>
    </>
  );
};

export default HomeHero;
